const strings = {
  title: (responsibleName: string) => `Obrigada, ${responsibleName}!`,
  description:
    'Um de nossos corretores entrará em contato via WhatsApp em breve',
  note: 'Previsão de contato: em até 12 horas',
  linkLabel: 'Ir para página inicial',
  reaccessedSimulation: {
    title: `Estamos cuidando do seu atendimento`,
    description: `Vimos que você já entrou em contato recentemente. Um de nossos corretores entrará em contato via WhatsApp`
  }
}

export { strings }
